<template>
  <div id="app">
      <div class="top">
        <h1>药知企业教育平台</h1>
        <h3>专一、专注、专业</h3>
        </div>
    <div class="main">
      <h1 class="center">验证码登录</h1>
      <el-steps :active="active" finish-status="success">
        <el-step title="验证方式"></el-step>
        <el-step title="安全验证"></el-step>
      </el-steps>
      <div class="con" v-if="active === 0">
        <div @click="num=1"><el-radio class="step1" v-model="radio" label="1">邮箱验证</el-radio></div>
        <div @click="num=2"><el-radio class="step1" v-model="radio" label="2">手机号验证</el-radio></div>
        <br />
        <div class="con-button">
          <el-button @click="next(1)">下一步</el-button>
        </div>

      </div>
      <div class="con" v-if="active === 1">
        <div id="email" v-show="num==1">
          <el-input placeholder="请输入邮箱" v-model.trim="data.mail"><template slot="prepend"><i class="el-icon-message"></i></template></el-input>
          <el-input v-model.trim="data.mailcode" placeholder="请输入验证码"><template slot="prepend"><i class="el-icon-key"></i></template><el-button slot="append" @click="send_code()">{{check_text}}</el-button></el-input>
        </div>
        <div id="phone" v-show="num==2">
            <el-input placeholder="请输入手机号" v-model.trim="data.phone"><template slot="prepend"><i class="el-icon-phone-outline"></i></template></el-input>
          <el-input v-model.trim="data.phonecode" placeholder="请输入验证码"><template slot="prepend"><i class="el-icon-key"></i></template><el-button slot="append" @click="send_code()">{{check_text}}</el-button></el-input>
        </div >
        <br />
        <div class="con-button">
          <el-button @click="back(0)">上一步</el-button>
          <el-button @click="next(2)">登录</el-button>
        </div>
      </div>
      <div>
        <el-dialog title="经检测您有多家企业账户" :visible.sync="dialogFormVisible">
          <el-form :model="data">
            <el-form-item label="请您选择登录账户" :label-width="formLabelWidth">
              <el-select v-model="data.info" placeholder="请您选择登录账户" style="width: 75%;">
                <el-option v-for="(item,index) in select_list" :key="index" :label="item.company.name" :title="item.rale_name" :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click= "select_user()">确 定</el-button>
          </div>
        </el-dialog>
      </div>

    </div>
  <footerbom></footerbom>
  </div>
</template>

<script>
  import Footer from '../components/index/public/NavFooter.vue';
  export default {
     name: 'App',
    data() {
      return {
        active: 0,
        radio: '1',
        num:1,
        check_text:'获取验证码',
        data:{
          phone:'',
          mail: '',
          phonecode:'',
          mailcode:'',
          pwd:'',
          pwd_re:'',
        },
        select_list:'',
        select_form:{},
        dialogFormVisible: false,
        formLabelWidth: '30%',
        timer:null,
        last:60,
      };
    },
    components:{
      footerbom:Footer,
    },
    methods: {
      select_user(){
        let _this=this;
        _this.axios.post('/v2/login/select_login', {
          data: _this.data.info //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg);
              localStorage.setItem('authorization', res.data.data.token.token)
              console.log(res.data.data.token.token);
              _this.$store.commit('info_save', res.data.data.info);
              _this.dialogFormVisible=false;
              _this.$router.push({path:'/home'})
            }else{
            //   _this.loginCode.error_msg=res.data.msg;
            //   if(res.data.msg.indexOf('用户名')!='-1'){
            //     _this.change_status('name');
            //   }else if(res.data.msg.indexOf('密码')!='-1'){
            //     _this.change_status('pwd');
            //   }else if(res.data.msg.indexOf('验证码')!='-1'){
            //     _this.change_status('code');
            //   }else{
            //     _this.loginCode.name=false;
            //     _this.loginCode.pwd=false;
            //     _this.loginCode.code=false;
            //     _this.$message.error(res.msg);
            //   }
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      //下一步
      next(num) {
        let _this=this;
        if(num==2 && !_this. info_check){
           _this.check_msg();
            return false;
        }
        _this.active = num;
      },
      //上一步
      back(num) {
        this.active = num;
      },
      //跳转登录页面
      login () {
        this.$router.push('/login')
      },
      //收到验证码倒计时
      change_info_check(){
        let _this=this;
        if(_this.timer == null) {
          _this.timer = setInterval( () => {
            if(_this.last>0){
              _this.check_text=_this.last+'s后重新获取';
              _this.last--;
            }else{
              clearInterval(_this.timer);
              _this.timer=null;
              _this.last=60;
              _this.check_text='获取验证码';
            }
          }, 1000)
        }
      },
      //获取验证码
      send_code(){
        let _this=this;
        if(_this.check_text!='获取验证码'){
          return false;
        }
        if(_this.num==1){
          _this.data.type='mail';
          _this.data.value=_this.email;
        }else{
          _this.data.type='phone';
          _this.data.value=_this.phone;
        }
        _this.data.msg='5'
        _this.axios.post('/v2/login/send_code', {
          data: _this.data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg);//弹框
              _this.change_info_check();
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      //确认验证码
      check_msg(){
        let _this=this;
        if(_this.num==1){
          _this.data.type='mail';
        }else{
          _this.data.type='phone';
        }
        _this.axios.post('/v2/login/check_msg', {
          data: _this.data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code!='1'){
              _this.$message.error(res.data.msg)
            }else{
              _this.select_list=res.data.data;
              _this.active = 2;
              _this.dialogFormVisible=true;
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },

    },
  }
</script>

<style scoped>
  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .center {
    text-align: center;
  }
  .top{
    width: 60%;
    height: 120px;
    background-color: #336397;
    color: white;
    padding: 0 20%;
  }
  .top h1{
    padding: 30px;
    float: left;
    margin: 0;
  }
  .top h3{
    padding: 20px;
    margin: 0;
    float: right;
    position: relative;
    right: 20px;
    top: 50px;
  }
  .main {
    min-height: calc(100vh - 260px);
    width: 60%;
    margin: 0 20%;
  }
  .main h1{
    margin: 0;
     padding: 20px;
   }
  .con {
    width: 60%;
    margin: 20px 20%;
  }

  .step1 {
    margin: 20px;
  }

  .con-button {
    margin-top: 30px;
    text-align: center;
  }
  .con .el-input-group{
    margin: 20px;
  }
  .success{
    color: green;
    font-size: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/y_z_code.vue